import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { SupportedLanguage } from '../models/supported-language.model';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private defaultLanguage: string;
  private readonly supportedLanguages: SupportedLanguage[] = [{
    code: 'hu',
    name: '🇭🇺 Magyar',
    isDefault: true
  }, {
    code: 'en',
    name: '🇺🇸 English',
    isDefault: false
  }];

  private readonly storageKey = 'lang';

  readonly languageChanged$ = new BehaviorSubject<string>('');

  constructor(private translate: TranslateService) {
    this.defaultLanguage = this.supportedLanguages.find(lang => lang.isDefault)?.code || 'hu';

    const current = this.getCurrentLanguage();
    this.languageChanged$.next(current);
  }

  getCurrentLanguage(): string {
    const storedLang = localStorage.getItem(this.storageKey);
    if (storedLang && this.supportedLanguages.find(lang => lang.code === storedLang)) {
      return storedLang;
    }

    const browserLang = this.translate.getBrowserLang();
    if (browserLang && this.supportedLanguages.find(lang => lang.code === browserLang)) {
      return browserLang;
    }

    return this.defaultLanguage;
  }

  getSupportedLanguages(): SupportedLanguage[] {
    return this.supportedLanguages;
  }

  async setLanguage(lang: string): Promise<void> {
    const supportedLang = this.supportedLanguages.find(x => x.code === lang);
    
    if (supportedLang) {
      await firstValueFrom(this.translate.use(lang));
      localStorage.setItem(this.storageKey, lang);
      console.log(`Language changed to: ${lang}`);
      this.languageChanged$.next(lang); // <== ESEMÉNY KÜLDÉSE
    }
  }

  initializeLanguage(): void {
    const currentLang = this.getCurrentLanguage();
    this.translate.use(currentLang);
    this.languageChanged$.next(currentLang); // <== ESEMÉNY KÜLDÉSE
  }
}
